export default __webpack_public_path__ + "images/1b99d1de3dba00559865800a9cb4f757-running.webp";